(() => {
  if (!document.body.classList.contains('ak-guided-page')) return;
  let pending = false;
  function update() {
    pending = false;
    const section = document.querySelector('.ak-guided-section');
    const primary = section?.querySelector('.product-add-to-cart__button');
    const bar = section?.querySelector('.product-sticky-add-to-cart');
    if (!primary || !bar) return;
    bar.classList.toggle('ak-sticky-visible', primary.getBoundingClientRect().bottom < 0);
  }
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  document.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  const section = document.querySelector('.ak-guided-section');
  if (section) new MutationObserver(schedule).observe(section, {childList:true,subtree:true});
  schedule();
})();
